// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1FiXW","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__ws2jB"};